





































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { UserStore } from '@/store'
import { Auth } from '@aws-amplify/auth'

export default Vue.extend({
  name: 'auth-sign-in',
  data: () => ({
    email: null,
    password: null,
    show: false,
    error: null,
    showError: false,
    loading: false,
  }),
  methods: {
    async signIn() {
      this.email = this.email.trim()
      this.loading = true
      const userstore = getModule(UserStore, this.$store)
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      Auth.signIn(this.email, this.password)
        .catch(error => {
          if (error.name === "UserNotFoundException") {
            return Auth.signIn(this.email.toLowerCase(), this.password)
          }
          throw error
        })
        .then(user => {
          localStorage.removeItem('user.config')
          userstore.setUser(user)
        })
        .then(() => {
          userstore.setAws({ user: userstore.User, condition: 'logIn' })
        })
        .then(() => {
          this.$notify('Cloud Data Synchronized', 'success')
          this.loading = false
          this.showError = false
        })
        .then(() => self.$nextTick())
        .then(() => {
          this.$emit('set-state', 'signed-in')
        })
        .catch(error => {
          this.loading = false
          this.showError = true
          this.error = `${error.message}<br><div class='text-right'>${error.name}</div>`
        })
    },
  },
})
